import { addClass, removeClass } from './css-class';

/**
 * 切换主题
 * @param theme - 主题的类名
 */
export function toggleAppThemeClassName(theme: string) {
  const { documentElement } = window.document;
  // lowcode-theme-dark 暗黑
  // lowcode-theme-white 高亮
  // lowcode-theme-primary 常规
  // 移除已有的主题类名
  Array.from(documentElement.classList).forEach((className) => {
    if (className.includes('theme')) {
      removeClass(documentElement, className);
    }
  });

  // 设置主题
  addClass(documentElement, `lowcode-theme-${theme}`);
  window.__VAST2T_LOWCODE__.theme = theme;
}
